import { ReactNode, useEffect, useState } from 'react';

import { List, Typography } from '@mui/material';

import { useLocation } from '@redwoodjs/router';

import { GenericCardProps } from 'src/types';

import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

export interface NavGroupProps {
    item: {
        id?: string;
        type?: string;
        icon?: GenericCardProps['iconPrimary'];
        children?: NavGroupProps['item'][];
        title?: ReactNode | string;
        caption?: ReactNode | string;
        color?: 'primary' | 'secondary' | 'default' | undefined;
    };
}

const NavGroup = ({ item }: NavGroupProps) => {
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const location = useLocation();

    useEffect(() => {
        // Whenever the location changes, check if we are on the profile page.
        // If we are, collapse all menu groups by setting selectedId to null.
        if (location.pathname === '/profile') {
            setSelectedId(null);
        }
    }, [location]);

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return (
                    <NavCollapse
                        key={menu.id}
                        menu={menu}
                        level={1}
                        selectedId={selectedId}
                        setSelected={setSelectedId}
                    />
                );
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <List>{items}</List>
        </>
    );
};

export default NavGroup;
